import {NfGlobalMessage} from "../NfGlobalMessage";
import {NfMessage, NfMessageType} from "../NfMessage";
import {GetAvailability} from "./GetAvailability";
import type {RoomAvailabilityResponse} from "../Models/RoomAvailabilityResponse";

/**
 * Response with availability data for multiple widgets
 */
export class MultiAvailabilityData extends NfGlobalMessage {
    public availabilityRequest: GetAvailability = {} as GetAvailability;
    public availabilityData: { [widgetId:number]: RoomAvailabilityResponse } = {};
    public persistentMessage = true;

    public constructor(availabilityRequest: GetAvailability | MessageEvent<MultiAvailabilityData>, availabilityData?: { [widgetId:number]: RoomAvailabilityResponse }) {
        super(NfMessageType.MultiAvailabilityData, arguments.length > 1);
        if (NfMessage.isMessageEvent(availabilityRequest)) {
            Object.assign(this, availabilityRequest.data);
            if (this.availabilityRequest) {
                this.availabilityRequest = new GetAvailability(new MessageEvent('message', {data: this.availabilityRequest}));
            }
        } else {
            if (!availabilityRequest) {
                throw Error('availabilityRequest jest wymagany');
            }
            this.availabilityRequest = availabilityRequest;

            if (!availabilityData) {
                throw Error('availabilityData jest wymagany');
            }
            this.availabilityData = availabilityData;
        }
    }
}

NfMessage.creationCallbacks[NfMessageType.MultiAvailabilityData] = (event) => {
    return new MultiAvailabilityData(event);
}
